import { useMemo } from 'react';

export default ({
  originalWidth = 0,
  originalHeight = 0,
  originalMaxWidth = 0,
  originalMaxHeight = 0,
}) =>
  useMemo(() => {
    let width = originalWidth || originalMaxWidth;
    let height = originalHeight || originalMaxHeight;

    const heightAuto = String(height) === 'auto';
    const widthAuto = String(width) === 'auto';

    if (!heightAuto && height > originalMaxHeight) {
      width = width * (originalMaxHeight / height);
      height = originalMaxHeight;
    }

    if (!widthAuto && width > originalMaxWidth) {
      height = height * (originalMaxWidth / width);
      width = originalMaxWidth;
    }

    return {
      width,
      height,
      maxWidth: widthAuto ? originalMaxWidth : null,
      maxHeight: heightAuto ? originalMaxHeight : null,
    };
  }, [originalWidth, originalHeight, originalMaxWidth, originalMaxHeight]);
